const rangeData = [
  { range: [0.8, 1], opacity: 0.3 },
  { range: [0.6, 0.8], opacity: 0.25 },
  { range: [0.4, 0.6], opacity: 0.2 },
  { range: [0.2, 0.4], opacity: 0.15 },
  { range: [0, 0.2], opacity: 0.1 },
]

const getOpacityInRange = (num) => {
  for (const { range, opacity } of rangeData) {
    if (num >= range[0] && num <= range[1]) {
      return opacity
    }
  }
}

const Graph = ({ proportion, keyword, h = 42 }) => {
  const opacity = getOpacityInRange(proportion)
  return (
    <div style={{ height: h }} className="mb-4 w-full rounded-[5px] bg-gray-100">
      <div
        style={{
          width: `${proportion * 100}%`,
        }}
        className={`Body1-16Md flex h-[42px] items-center justify-start whitespace-nowrap rounded-[5px] bg-purple-100 pl-12 font-medium text-purple-900 `}
      >
        "{keyword}"
      </div>
    </div>
  )
}
export default Graph
